const THEMES_VERSIONED_PAYLOAD_PATTERN =
  /^\/v1\/themes\/(?:landing|finviz|strength-summary|universe|expected-return\/(?:stocks|subthemes|themes)\/[^/]+)\/(?:final|provisional)\/versions\/\d{4}-\d{2}-\d{2}\/[^/?#]+\.json$/;
const CROSS_ASSET_PRIVATE_VERSIONED_PAYLOAD_PATTERN =
  /^\/v1\/cross-asset\/(?:delayed|full)-runs\/(?:final|provisional)\/(?:dashboards\/[^/]+\/[^/]+\/)?versions\/\d{4}-\d{2}-\d{2}\/[^/?#]+\.json$/;
const STRATEGIES_PRIVATE_PAYLOAD_PATTERN =
  /^\/v1\/strategies\/private\/[^/]+\/(?:final|provisional)\/[^/?#]+\.json$/;

export const isSignedThemesSnapshotPayloadPath = (path: string): boolean =>
  THEMES_VERSIONED_PAYLOAD_PATTERN.test(path);

export const isPrivateSnapshotPayloadPath = (path: string): boolean =>
  CROSS_ASSET_PRIVATE_VERSIONED_PAYLOAD_PATTERN.test(path) ||
  STRATEGIES_PRIVATE_PAYLOAD_PATTERN.test(path);

export const buildSnapshotPayloadProxyUrl = (
  path: string,
  cacheBustToken?: string | null
): string => {
  const params = new URLSearchParams({ path });
  if (cacheBustToken) {
    params.set('_ts', cacheBustToken);
  }
  return `/api/snapshots/payload?${params.toString()}`;
};
